var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLibertad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46 23v3h-6v-3c0-1.596 1.283-3 3-3 1.65 0 3 1.35 3 3z",
    fill: "#f2c8a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46 26v10c0 1.8-.6 3.46-1.6 4.79-.28.36-.4.82-.4 1.27v11.94h-20v-8.86c0-.81-.51-1.51-1.25-1.84-2.8-1.24-4.75-4.04-4.75-7.3h2c1.1 0 2-.9 2-2v-8z",
    fill: "#f2c8a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 20c-.18 0-.35.01-.51.05 1.42.23 2.51 1.47 2.51 2.95v13c0 1.8-.6 3.46-1.6 4.79-.28.36-.4.82-.4 1.27v11.94h1v-11.94c0-.45.12-.91.4-1.27 1-1.33 1.6-2.99 1.6-4.79 0-4.989 0-8.01 0-13 0-1.65-1.35-3-3-3z",
    fill: "#d1aa81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24 46h20v9h-20z",
    fill: "#d2aa82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22 26v8c0 1.1-.9 2-2 2h-2v-8c0-1.1.9-2 2-2z",
    fill: "#f2c8a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 26c-1.1 0-2 .9-2 2v5.46c.591-.527 1.074-1.176 1.418-1.901.167-.353.543-.559.934-.559h.648v3c0 .74.4 1.38 1 1.73v-4.73-5z",
    fill: "#d1aa81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 26h-6v-7c0-1.657 1.343-3 3-3 1.657 0 3 1.343 3 3z",
    fill: "#f2c8a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28 19v6.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5v-6.5c0-1.476-1.079-2.725-2.5-2.95.16-.04.33-.05.5-.05 1.654 0 3 1.348 3 3z",
    fill: "#d1aa81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 26h-6v-5c0-1.657 1.343-3 3-3 1.657 0 3 1.343 3 3z",
    fill: "#f2c8a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 21v4.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5v-4.5c0-1.476-1.079-2.725-2.5-2.95.16-.04.33-.05.5-.05 1.654 0 3 1.348 3 3z",
    fill: "#d1aa81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 26h-6v-4c0-1.657 1.343-3 3-3 1.657 0 3 1.343 3 3z",
    fill: "#f2c8a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40 22v3.5c0 .276-.224.5-.5.5-.276 0-.5-.224-.5-.5v-3.5c0-1.476-1.079-2.725-2.5-2.95.16-.04.33-.05.5-.05 1.654 0 3 1.348 3 3z",
    fill: "#d1aa81"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m45 56h-22c-.552 0-1-.448-1-1v-7c0-.552.448-1 1-1h22c.552 0 1 .448 1 1v7c0 .552-.448 1-1 1z",
    fill: "#00a0c8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 52.5,
    fill: "#0082aa",
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 51.5,
    fill: "#f0f0f0",
    r: 2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m33 9v2c0 .553-.448 1-1 1s-1-.447-1-1v-2c0-.553.448-1 1-1s1 .447 1 1z",
    fill: "#c80a50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38.707 11.707-1.414 1.414c-.391.391-1.023.391-1.414 0s-.391-1.023 0-1.414l1.414-1.414c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414z",
    fill: "#fab400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.121 13.121c-.391.391-1.023.391-1.414 0l-1.414-1.414c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l1.414 1.414c.391.391.391 1.023 0 1.414z",
    fill: "#00a0c8"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m22 26h-1.683c-.372 0-.728-.2-.886-.537-1.116-2.387-3.75-3.921-6.665-3.34-2.291.456-4.153 2.295-4.631 4.582-.81 3.879 2.128 7.295 5.865 7.295 2.394 0 4.455-1.404 5.417-3.432.17-.359.553-.568.95-.568h1.633z",
    fill: "#fab400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.098 29.634-1.098-.634 1.098-.634c.479-.276.642-.888.366-1.366-.277-.478-.888-.644-1.366-.366l-1.098.634v-1.268c0-.552-.448-1-1-1s-1 .448-1 1v1.268l-1.098-.634c-.48-.277-1.09-.112-1.366.366-.276.479-.112 1.09.366 1.366l1.098.634-1.098.634c-.479.276-.642.887-.366 1.366.275.476.886.643 1.366.366l1.098-.634v1.268c0 .552.448 1 1 1s1-.448 1-1v-1.268l1.098.634c.48.276 1.091.109 1.366-.366.276-.479.113-1.09-.366-1.366z",
    fill: "#dc9600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 26v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-2v-3c0-.55-.45-1-1-1s-1 .45-1 1v3h-2v4h8c1.1 0 2-.9 2-2s-.9-2-2-2z",
    fill: "#fab400"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.098 28.634-1.098-.634 1.098-.634c.479-.276.642-.888.366-1.366-.277-.478-.888-.644-1.366-.366l-1.098.634v-1.268c0-.552-.448-1-1-1s-1 .448-1 1v1.268l-1.098-.634c-.48-.277-1.09-.112-1.366.366-.276.479-.112 1.09.366 1.366l1.098.634-1.098.634c-.479.276-.642.887-.366 1.366.275.476.886.643 1.366.366l1.098-.634v1.268c0 .552.448 1 1 1s1-.448 1-1v-1.268l1.098.634c.48.276 1.091.109 1.366-.366.276-.479.113-1.09-.366-1.366z",
    fill: "#0a5078"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLibertad);
export default __webpack_public_path__ + "static/media/libertad.459253940fe0486b72129fd49df6113c.svg";
export { ForwardRef as ReactComponent };